/**
 * The one way a stored or provider-sourced URL becomes an `href`.
 *
 * Writers refuse anything but http(s) (backend `services/urls.py`), but a row
 * stored before its writer was guarded, or a value a provider such as Classroom
 * supplied, reaches the page unchecked. React 19 neutralises a `javascript:`
 * href at render; it does nothing for `data:` and is framework behaviour, not
 * this product's contract. So a renderer passes the value through here and
 * shows plain text when the answer is null.
 */
const WEB_SCHEME = /^https?:\/\//i;

export function safeHref(value: string | null | undefined): string | null {
  if (typeof value !== "string") return null;
  const candidate = value.trim();
  if (!WEB_SCHEME.test(candidate)) return null;
  try {
    const { protocol, hostname } = new URL(candidate);
    return (protocol === "http:" || protocol === "https:") && hostname ? candidate : null;
  } catch {
    return null;
  }
}
